// Client for the deployed Cloudflare Worker prompt engine.
import { supabase } from './supabase';

const WORKER_URL = import.meta.env.VITE_WORKER_URL || 'https://raagengine-api.ashutoshpatney1.workers.dev';

export interface GenerateInput {
  instA: string; instB: string; instC: string;
  mood: string; scale: string; freq: string;
  flavor: string; bpm: string; duration: string;
  arrangement: string; reverb: string;
  ambient: string; harmonic: string;
  brainwave: string; subject: string;
  benefit: string; listener: string;
  session_len: string; title: string;
  channel: string; custom_tags: string;
  scene?: string; world?: string; region?: string;
  platforms?: string[];
}

export interface GenerateResult {
  suno: string;
  udio: string;
  styleTag: string;
  platforms?: Record<string, string>;
}

export class GenerateError extends Error {
  constructor(public code: string, message: string, public status?: number) { super(message); }
}

export async function generatePrompts(input: GenerateInput): Promise<GenerateResult> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new GenerateError('not_signed_in', 'Please sign in to generate.');

  const res = await fetch(`${WORKER_URL}/api/generate`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(input),
  });

  if (!res.ok) {
    let body: any = {};
    try { body = await res.json(); } catch {}
    throw new GenerateError(body.error || 'request_failed', body.detail || `Failed (${res.status})`, res.status);
  }
  return res.json() as Promise<GenerateResult>;
}

// Legacy stubs — GeneratorView uses these.
export const FEEL_MAP: Record<string, any> = {};
export const VAR_MODS: Array<{ tag: string }> = [{ tag: 'calm' }];
export const ACTIVITY_MODS: Record<string, any> = {};
export function buildAllPrompts(_d: any, _v: string) {
  return { sunoProse: '', sunoTag: '', udioProse: '', stableProse: '', aiBrief: '' };
}
export async function generateAIContent(_k: string, _p: any): Promise<any> {
  return { yt_titles: [], yt_desc: '', suggestions: [], social_captions: { ig: '', tt: '' } };
}
